module.exports = __webpack_public_path__ + "img/svg/logo.ee67910ca78d75a0445c6fc3b88cca1c.svg";